import { AppConstant } from 'src/app/config/app.constant';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { Injectable } from "@angular/core";
import { APIs } from '../config/api.constant';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ParkiteReportService {

  url: string;

  constructor(private apiService: ApiService, private http: HttpClient) { }

  getEmployeeReports(body?: any): Observable<any> {
    return this.apiService.post(APIs.getEmployeesReportData, body, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getFireWardenReportData(body?: any): Observable<any> {
    return this.apiService.post(APIs.getFireWardenReportData, body, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getVMSReportData(body?: any): Observable<any> {
    return this.apiService.post(APIs.getVMSReportData, body, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getVMSReportBPData(body?: any): Observable<any> {
    return this.apiService.post(APIs.getVMSBPReportData, body, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };


  getInvitationType(): Observable<any> {

    const paramObj = {
    };
    return this.apiService.get(APIs.getInvitationType, paramObj).pipe(map(response => {
      return response;
    }));
  };

  // getEventsCategory(): Observable<any> {
  //   return this.apiService.get(APIs.getEventsCategoryData, '',{
  //       Authorization : "bearer " + localStorage.getItem(AppConstant.localStorage.token)
  //     }).pipe(map(response => {
  //       return response;
  //     }));
  // };

  getEventsCategory() {
    return this.apiService.get(APIs.GetEventsCategory).pipe(map(response => {
      return response;
    }));
  }

  getEventsReportData(body?: any): Observable<any> {

    return this.apiService.post(APIs.getEventsReportData, body).pipe(map(response => {
      return response;
    }));
  };

  getPaymentReport(body?: any): Observable<any> {

    return this.apiService.post(APIs.getPaymentcharge, body).pipe(map(response => {
      return response?.list;
    }));
  };

  getPaymentRecieptReport(body?: any): Observable<any> {

    return this.apiService.post(APIs.getPaymentReciept, body).pipe(map(response => {
      return response?.list;
    }));
  };

  getTenant(): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getTenant + '?locationId=' + locationId;
    const paramObj = {
    };
    return this.apiService.get(this.url, paramObj, {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getRfids(tenantId, FromDate, ToDate): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    let parkId = localStorage.getItem("parkId") ?? '';
    this.url = APIs.getRfidList;
    const paramObj = {
      tenantIds: tenantId,
      fromDate: FromDate,
      toDate: ToDate,
      locationId: locationId,
      parkId: parkId
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getSurveyReport(surveyType, FromDate, ToDate): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    let parkId = localStorage.getItem("parkId") ?? '';
    this.url = APIs.getSurveyReportList;
    const paramObj = {
      surveyTypes: surveyType,
      fromDate: FromDate,
      toDate: ToDate,
      locationId: locationId,
      parkId: parkId
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  getFacilityReport(facilityType, FromDate, ToDate): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    let parkId = localStorage.getItem("parkId") ?? '';
    this.url = APIs.getFacilytyReport;
    const paramObj = {
      facilityType: facilityType,
      fromDate: FromDate,
      toDate: ToDate,
      locationId: locationId,
      parkId: parkId
    };
    return this.apiService.post(this.url, paramObj, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  submitVmsReport(formData: any) {
    // Your API endpoint
    const url = APIs.getVMSExcelReportData;
    return this.http.post(url, formData, { responseType: 'blob' })
  }

  getMeetingRoomReportData(body?: any): Observable<any> {
    return this.apiService.post(APIs.getMeetingRoomReportData, body, '', {
      Authorization: "bearer " + localStorage.getItem(AppConstant.localStorage.token)
    }).pipe(map(response => {
      return response;
    }));
  };

  submitMeetingRoomReport(formData: any) {
    // Your API endpoint
    const url = APIs.getMeetingRoomExcelReportData;
    return this.http.post(url, formData, { responseType: 'blob' })
  }

}
